import { Box, Grid, Menu, MenuItem, Stack } from '@mui/material';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useAvisoObra } from './hooks/useAvisoObra';
import SectionHeader from '../../components/SectionHeader';
import SearchToolbar from '../../components/SearchToolbar/SearchToolbar';
import { useTranslation } from 'react-i18next';

import NoTableDataImageSIMP from '../../assets/image/empty-state-establecimientos-simp.png';
import NoTableDataImageBO from '../../assets/image/empty-state-establecimientos-backoffice.png';
import DataTable from '../../components/DataTable/DataTable';
import { useRoles } from '../../hooks/useRoles';
import { useNavigate } from 'react-router-dom';
import StateBadge from '../../components/StatesBadge/StatesBadge';
import AvisoObraFilters from './components/AvisoObraFilters';
import { EstadoAvisoObraEnum } from './consts/avisoObra.types';
import StateBadgeAvisoObra from './components/Chips/StateBadgeAvisoObra';
import AvisoObraGrid from './components/AvisoObraGrid';
import DrawerAvisoObra from './components/AvisoObraDrawer';
import { useState } from 'react';

const columnWidths = ['10%', '20%', '10%', '10%', '10%', '10%', '10%', '10%', '10%'];

const columnTitles = ({ t }: any): string[] => [
    t('table.columns.nroObra'),
    t('table.columns.direccion'),
    t('table.columns.localidad'),
    t('table.columns.provincia'),
    t('table.columns.programa'),
    t('table.columns.tipoObra'),
    t('table.columns.inicio'),
    t('table.columns.fin'),
    t('table.columns.estado'),
    t('table.columns.fechaAlta'),
    t('table.columns.acciones')
];

const AvisoObraIndex = () => {
    const { isMobile } = useIsMobile();
    const { isAdminBO } = useRoles();
    const { t } = useTranslation('avisoObra');
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerAction, setDrawerAction] = useState<'Suspender' | 'Extender' | null>(null);
    const [selectedObra, setSelectedObra] = useState<any>(null);

    const {
        avisos,
        isFetching,
        filters,
        extraFilters,
        anchorEl,
        selectedItem,
        handleOpenMenu,
        handleCloseMenu,
        handleChangeExtraFilters,
        clearFilters,
        handleSubmitSearch,
        setFilters,
        contratoOrganismoCentral
    } = useAvisoObra();

    return (
        <Grid container>
            <Grid item xs={12}>
                <SectionHeader>
                    <SectionHeader.Title>{t('header.title')}</SectionHeader.Title>
                    <SectionHeader.IconHeader
                        text={t('header.add')}
                        onClick={() => navigate('nuevo')}
                        showIcon={false}
                        disabled={!contratoOrganismoCentral}
                    />
                </SectionHeader>
            </Grid>
            <Grid item xs={12}>
                <SearchToolbar
                    inputSearchName=""
                    onChange={() => {}}
                    onClick={handleSubmitSearch}
                    showSearchInput={false}
                    clearFilters={clearFilters}
                >
                    <AvisoObraFilters
                        extraFilters={extraFilters}
                        handleChangeExtraFilters={handleChangeExtraFilters}
                    />
                </SearchToolbar>
            </Grid>
            <Grid item xs={12}>
                {!avisos?.data?.data?.length ? (
                    <Box
                        my={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                    >
                        <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                '& h4': { fontSize: '18px' },
                                '& p': {
                                    maxWidth: '360px',
                                    textAlign: 'center',
                                    margin: 0,
                                    fontSize: '16px'
                                }
                            }}
                        >
                            <img
                                src={isAdminBO ? NoTableDataImageBO : NoTableDataImageSIMP}
                                alt={'No aviso de obra'}
                            />
                            <h4>{t('table.noData.title')}</h4>
                            <p>{t('table.noData.description')}</p>
                        </Stack>
                    </Box>
                ) : (
                    <>
                        <AvisoObraGrid
                            avisos={avisos}
                            filters={filters}
                            setFilters={setFilters}
                            isFetching={isFetching}
                            onSelectRow={handleOpenMenu}
                        />
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                        >
                            <Box>
                                <MenuItem
                                    onClick={() => {
                                        console.log('Ver', selectedItem);
                                        handleCloseMenu();
                                    }}
                                >
                                    {t('actions.ver')}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        console.log('Descargar', selectedItem);
                                        handleCloseMenu();
                                    }}
                                >
                                    {t('actions.descargar')}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        handleCloseMenu();
                                        setDrawerAction('Extender');
                                        setSelectedObra(selectedItem);
                                        setDrawerOpen(true);
                                    }}
                                >
                                    {t('actions.extender')}
                                </MenuItem>

                                <MenuItem
                                    onClick={() => {
                                        handleCloseMenu();
                                        setDrawerAction('Suspender');
                                        setSelectedObra(selectedItem);
                                        setDrawerOpen(true);
                                    }}
                                >
                                    {t('actions.suspender')}
                                </MenuItem>
                            </Box>
                        </Menu>
                    </>
                )}
                <DrawerAvisoObra
                    open={drawerOpen}
                    setOpen={setDrawerOpen}
                    actionType={drawerAction}
                    selectedObra={selectedObra}
                    onSubmit={(data) => {}}
                />
            </Grid>
        </Grid>
    );
};

export default AvisoObraIndex;
